// extracted by mini-css-extract-plugin
export default {"videoContainer":"adVideoPlayer_videoContainer__qE40g","video":"adVideoPlayer_video__q1C-k","controls":"adVideoPlayer_controls__1Y6Mt","button":"adVideoPlayer_button__YMujV"};